var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainView',{attrs:{"movements":_vm.movementsPendingUserAction,"location":_vm.location,"fetchMovementsEvent":_vm.fetchMovementsPendingUserActionEvent,"viewTitle":"Movements Pending My Action","allowSearchByMonth":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }